module.exports = __webpack_public_path__ + "5d9f00383872a242653e9cc24588101d.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/AF.svg
// module id = wOB8
// module chunks = 0